var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.246 4.375c.399 0 .722.324.722.721v8.069l.933-.938a.723.723 0 1 1 1.02 1.024l-2.165 2.163a.723.723 0 0 1-1.02 0l-2.165-2.163a.723.723 0 1 1 1.02-1.024l.934.938V5.096c0-.397.323-.721.721-.721ZM9.576 11.667c0-.344.31-.625.693-.625h4.677c.383 0 .693.281.693.625s-.31.625-.693.625H10.27c-.382 0-.693-.281-.693-.625ZM9.576 15c0-.344.31-.625.693-.625h2.945c.383 0 .693.281.693.625s-.31.625-.693.625H10.27c-.382 0-.693-.281-.693-.625ZM9.576 8.333c0-.344.31-.625.693-.625h6.41c.382 0 .693.281.693.625s-.31.625-.693.625h-6.41c-.382 0-.693-.281-.693-.625ZM10.257 4.375h8.166c.376 0 .68.281.68.625s-.304.625-.68.625h-8.166c-.376 0-.68-.281-.68-.625s.304-.625.68-.625Z",
    fill: "#5D5BEA"
  })));
};
export default SvgSort;